<template>
  <div>
    <b-alert show dismissible>
      {{ $lang.change_pass_name | replace(item.person.name) }}
    </b-alert>
    <b-form @submit.prevent="save" v-show="!isLoading" autocomplete="off">
      <b-row>
        <b-col cols="12">
          <b-form-group
            :label="$lang.username"
            label-for="username"
            :label-cols="$config.form.labelCol"
          >
            <requiredComponent
              slot="label"
              :label="$lang.username"
              :rules="$v.username.$params"
            />
            <b-form-input
              id="username"
              type="text"
              autofocus
              :state="$v.username.$dirty ? !$v.username.$error : null"
              v-model="$v.username.$model"
            ></b-form-input>

            <b-form-invalid-feedback id="a-feedback"
              >{{ $lang.error_numeric | replace($lang.username) }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group
            :label="$lang.password"
            label-for="password"
            :label-cols="12"
          >
            <requiredComponent
              slot="label"
              :label="$lang.password"
              :rules="$v.password.$params"
            />
            <b-input-group>
              <b-form-input
                id="password"
                :type="show_password ? 'text' : 'password'"
                :state="$v.password.$dirty ? !$v.password.$error : null"
                v-model="$v.password.$model"
              ></b-form-input>
              <b-input-group-text
                @click.prevent="toggleShowNewVisible"
                style="cursor: pointer"
              >
                <a href="#">
                  <i
                    :class="show_password ? 'fa fa-eye' : 'fa fa-eye-slash'"
                    aria-hidden="true"
                  ></i>
                </a>
              </b-input-group-text>
              <b-form-invalid-feedback id="password-feedback">
              </b-form-invalid-feedback>
              <b-form-invalid-feedback
                v-if="!$v.password.required"
                id="password-feedback"
              >
                {{
                  $lang.error_required | replace($lang.password)
                }}</b-form-invalid-feedback
              >
              <b-form-invalid-feedback
                v-if="$v.password.required && !$v.password.minLength"
                id="password-feedback"
              >
                {{
                  $lang.error_min_value | replace($lang.password, 8)
                }}</b-form-invalid-feedback
              >
            </b-input-group>
            <small class="form-text text-muted text-left">{{
              $lang.password_template
            }}</small>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group
            :label="$lang.password_confirmation"
            label-for="password_confirmation"
            :label-cols="12"
          >
            <requiredComponent
              slot="label"
              :label="$lang.password_confirmation"
              :rules="$v.password_confirmation.$params"
            />
            <b-input-group>
              <b-form-input
                id="password_confirmation"
                :type="show_current_password ? 'text' : 'password'"
                :state="
                  $v.password_confirmation.$dirty
                    ? !$v.password_confirmation.$error
                    : null
                "
                v-model="$v.password_confirmation.$model"
                aut
              ></b-form-input>
              <b-input-group-text
                @click.prevent="toggleShowConfirmVisible"
                style="cursor: pointer"
              >
                <a href="#">
                  <i
                    :class="
                      show_current_password ? 'fa fa-eye' : 'fa fa-eye-slash'
                    "
                    aria-hidden="true"
                  ></i>
                </a>
              </b-input-group-text>
              <b-form-invalid-feedback
                v-if="!$v.password_confirmation.required"
                id="password_confirmation-feedback"
              >
                {{
                  $lang.error_required | replace($lang.password_confirmation)
                }}</b-form-invalid-feedback
              >
              <b-form-invalid-feedback
                v-if="
                  $v.password_confirmation.required &&
                  !$v.password_confirmation.minLength
                "
                id="password_confirmation-feedback"
              >
                {{
                  $lang.error_min_value
                    | replace($lang.password_confirmation, 8)
                }}</b-form-invalid-feedback
              >
              <div
                v-if="notSamePasswords"
                id="password_confirmation-feedback"
                class="notSamePasswords"
              >
                {{
                  $lang.error_not_match
                    | replace($lang.password_confirmation, $lang.password)
                }}
              </div>
            </b-input-group>
            <small class="form-text text-muted text-left">{{
              $lang.password_template
            }}</small>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group>
            <b-form-checkbox
              id="checkbox-1"
              v-model="send_sms"
              name="checkbox-1"
              value="1"
              unchecked-value="0"
            >
              {{ $lang.sendInfoUser
              }}<i
                class="fa fa-info-circle fa-lg text-info mx-1"
                v-b-tooltip.hover
                :title="$lang.sendInfoUser_tooltip"
              ></i
            ></b-form-checkbox>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <div class="form-group float-right">
            <b-button
              class="mx-1"
              variant="success"
              type="submit"
              :disabled="notSamePasswords"
            >
              <span>
                {{ $lang.submitButton }}
                <i class="fa fa-check"></i>
              </span>
            </b-button>
            <b-button
              class="mx-1"
              variant="danger"
              type="button"
              @click="cancel"
            >
              {{ $lang.cancelButton }}
              <i class="fa fa-ban"></i>
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import { required, minLength } from "vuelidate/lib/validators";

export default {
  validations: {
    username: {
      required,
    },
    password: {
      required,
      minLength: minLength(8),
    },
    password_confirmation: {
      required,
      minLength: minLength(8),
    },
  },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      username: null,
      password: null,
      password_confirmation: null,
      show_current_password: false,
      show_password: false,
      send_sms: 0,
      isLoading: false,
    };
  },
  computed: {
    notSamePasswords() {
      if (this.password_confirmation) {
        return this.password !== this.password_confirmation;
      } else {
        return false;
      }
    },
  },
  methods: {
    cancel() {
      this.$emit("cancel");
    },
    toggleShowConfirmVisible() {
      this.show_current_password = !this.show_current_password;
    },
    toggleShowNewVisible() {
      this.show_password = !this.show_password;
    },
    save() {
      this.$v.$touch();
      if (this.$v.$anyError) {
        return;
      }
      let payload = {
        username: this.username,
        password: this.password,
        password_confirmation: this.password_confirmation,
        send_sms: this.send_sms,
      };
      this.$emit("submit", payload);
    },
  },
  created() {
    if (this.item) {
      this.username = this.item.username;
    }
    this.password = "";
  },
};
</script>

<style>
.notSamePasswords {
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #f86c6b;
}
</style>
